import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageBusinessGoldCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Gold Business Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-gold-card.png',
  show: true,
  position: 'right'
};

export const BannerContentBusinessGoldCardMocks: GenericLabel = {
  title: 'Delta SkyMiles® Gold Business Card Member',
  subtitle: ''
};

export const BannerBusinessGoldCardMocks: CardCarouselBanner = {
  labels: BannerContentBusinessGoldCardMocks,
  image: BannerImageBusinessGoldCardMocks
};
